export const taskCenter = {
  syrw: 'Commence par une tâche, finit avec vous',
  zjlbt: 'Bonus BiWang USDT en continu',
  wdjj: 'Mon bonus',
  rwsm: 'Instructions de tâche',
  rwlb: 'Liste des tâches',
  jljl: 'Historique des récompenses',
  klq: 'Disponible',
  flzm: 'Porte des avantages BiWang',
  dcjl: 'Atteignez l’objectif et recevez des récompenses USDT tout au long de votre parcours',
  yjlq: 'Tout réclamer',
  lqcg: 'Récupéré avec succès',
  wdl: 'Non connecté',
  jxz: 'En cours',
  ylq: 'Déjà réclamé',
  rwjd: 'Progression de la tâche',
  xsrw: 'Tâches débutant',
  hyrw: 'Tâches de contrat',
  cjrz: 'Vérification primaire',
  gjrz: 'Vérification avancée',
  scbbjy: 'Premier trade Spot',
  schyjy: 'Premier trade de Contrat',
  sccz: 'Premier dépôt',
  schyhz: 'Premier transfert vers Contrat',
  jyl: 'Volume de trading',
  ylje: 'Montant du profit',
  ksje: 'Montant de la perte',
  dbkcbzj: 'Marge d’ouverture par position',
  rjl: 'Montant du dépôt',
  dbczje: 'Montant du dépôt unique',
  rwxq: 'Détails de la tâche'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/task/fr.js